// extracted by mini-css-extract-plugin
export default {"cardHeaderActionDiv":"FormCard_cardHeaderActionDiv__-0HGz","card":"FormCard_card__3S1Lm","row":"FormCard_row__HHdsf","title":"FormCard_title__6yCtl"};